'use client';

import { useView } from '@/lib/store/hooks';
import { PageHeaderProps } from '.';
import Box from '../ui/Box';
import Txt, { TxtProps } from '../ui/Txt';
import * as styles from './PageHeader.css';

type PageTitleProps = TxtProps<'h1'> & Partial<PageHeaderProps>;

export default function PageTitle({ children, ...props }: PageTitleProps) {
  const page = useView();
  const title = page?.pageTitle ?? page?.title ?? '';

  return (
    <Box className={styles.titleWrapper}>
      <Txt as="h1" variant="h1" cx={{ mB: 'none' }} {...props}>
        {children || title}
      </Txt>
    </Box>
  );
}
